import React, { useState } from "react";
import { createPortal } from "react-dom";

import { colors2, CONTENT_BODY_SM, OKELink, TagDisplayV2, UI_CAPTION, UI_TAG } from "oolib";
import { CardWrapperStyled, StyledButtonSecondaryCompact } from "./styled";

import { TagListStyled } from "../../../AnnoPlugin/AnnoLightbox/AnnoLightboxDisplay/styled";
import { SM_AnnoLightbox } from "../../../AnnoPlugin/AnnoLightbox/SM_AnnoLightbox";
import { groupTagsByCategory } from "../../utils";
import { __GetContentTypeConfigNew } from "../../../../../../../../utils/getters/gettersV2";
import { useAppSettingsContext } from "@/contexts/appSettingsContext";

const TagCategoryAndTags = ({ data = [] }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        flex: 1,
      }}
    >
      {data.map(({ tagCategory, tags }) => (
        <div>
          <UI_TAG>
            {__GetContentTypeConfigNew(tagCategory).general?.content?.title ||
              tagCategory}
          </UI_TAG>

          <TagListStyled>
            {tags.map((tag, i) => (
              <TagDisplayV2
                display={`${tag.display}`}
                style={{ borderRadius: "0.4rem", borderColor: colors2.grey10 }}
              ></TagDisplayV2>
            ))}
          </TagListStyled>
        </div>
      ))}
    </div>
  );
};

export const Cards = ({
  _id,
  text,
  tags,
  cached,
  handleApply,
  handleRemove,
  applied,
  translations,
  showTranslatedSuggestions,
  handleEditTags,
  tagTypesConfig,
}) => {
  const { APP_SETTINGS } = useAppSettingsContext();
  const activeLang = APP_SETTINGS.lang?.value;

  const [showEditLightbox, setShowEditLightbox] = useState(false);
  const [editValue, setEditValue] = useState({});

  const groupedTags = groupTagsByCategory(tags);

  const handleOpenEdit = (e) => {
    e.stopPropagation();
    // Shape adapter IN: suggestion tags are a flat array [{_id, display, tagCategory, ...}]
    // but SM_AnnoLightbox expects { tags: { collectionId, data: [...] } }
    setEditValue({
      tags: { collectionId: "tags", data: tags }
    });
    setShowEditLightbox(true);
  };

  const handleEditChange = (tagType, value) => {
    setEditValue(prev => ({ ...prev, [tagType]: value }));
  };

  const handleEditConfirm = () => {
    // Shape adapter OUT: SM_AnnoLightbox returns tags without tagCategory
    // (it strips it via convertMultiValueToTagsValue internally).
    // We need to re-add tagCategory so groupTagsByCategory doesn't skip them.
    const newTags = (editValue?.tags?.data || []).map(t => ({
      ...t,
      tagCategory: t.tagCategory || "tags",
    }));
    handleEditTags(_id, newTags);
    setShowEditLightbox(false);
  };

  const handleEditCancel = () => {
    setShowEditLightbox(false);
  };

  const getContent = () => {
    if (translations && translations[activeLang]) {
      return translations[activeLang].text;
    }
    return text;
  };

  return (
    <CardWrapperStyled>
      <CONTENT_BODY_SM>
        {showTranslatedSuggestions ? getContent() : text}
      </CONTENT_BODY_SM>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }}>
        <TagCategoryAndTags data={groupedTags} />
        {tagTypesConfig?.length > 0 && (
          <UI_CAPTION>
            <OKELink onClick={handleOpenEdit}>Edit</OKELink>
          </UI_CAPTION>
        )}
      </div>

      {showEditLightbox && createPortal(
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
          onClick={handleEditCancel}
        >
          <div onClick={e => e.stopPropagation()}>
            <SM_AnnoLightbox
              value={editValue}
              tagTypesConfig={tagTypesConfig}
              onChange={handleEditChange}
              handleOnConfirm={handleEditConfirm}
              handleOnCancel={handleEditCancel}
            />
          </div>
        </div>,
        document.body
      )}

      {import.meta.env.VITE_ENV !== "prod" && cached ? (
        <span>
          {" "}
          <TagDisplayV2 display="cached" />{" "}
        </span>
      ) : null}
      <div style={{ display: "flex", gap: "1rem" }}>
        {applied ? (
          <StyledButtonSecondaryCompact
            icon={"X"}
            S
            onClick={() => handleRemove({ _id })}
            remove={true}
          >
            Remove
          </StyledButtonSecondaryCompact>
        ) : (
          <StyledButtonSecondaryCompact
            icon={"Check"}
            S
            onClick={() => handleApply({ text, tagsData: groupedTags, _id })}
          >
            Apply
          </StyledButtonSecondaryCompact>
        )}
      </div>
    </CardWrapperStyled>
  );
};
